export const CATEGORIES = [
  {
    label: 'À la une',
    slug: 'a-la-une',
    order: 1,
    description: 'Les sujets essentiels du digital a ne pas manquer.'
  },
  {
    label: 'IA',
    slug: 'ia',
    order: 2,
    description: 'Usages concrets, outils et impacts de l intelligence artificielle.'
  },
  {
    label: 'Business & opportunités',
    slug: 'business-opportunites',
    order: 3,
    description: 'Modeles economiques, croissance et opportunites du secteur.'
  },
  {
    label: 'Aides & financements',
    slug: 'aides-financements',
    order: 4,
    description: 'Subventions, dispositifs publics et financements prives.'
  },
  {
    label: 'Bons plans',
    slug: 'bons-plans',
    order: 5,
    description: 'Promotions utiles, outils rentables et offres a surveiller.'
  },
  {
    label: 'Marketing & SEO',
    slug: 'marketing-seo',
    order: 6,
    description: 'Acquisition, contenu et referencement orientes resultats.'
  },
  {
    label: 'Analyses & opinions',
    slug: 'analyses-opinions',
    order: 7,
    description: 'Prises de recul, decryptages et points de vue argumentes.'
  },
  {
    label: 'Actu rapide',
    slug: 'actu-rapide',
    order: 8,
    description: 'Les infos flash a lire en quelques minutes.'
  }
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((category) => [category.slug, category]));

export const getCategoryBySlug = (slug) => CATEGORY_MAP[slug] || null;

export const getCategoryLabel = (slug) => getCategoryBySlug(slug)?.label || slug;
